import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { QueryKeys } from '../utils/queryKeyGenerator'
import { handleGetRequest } from '../utils/api-handler.util'

export default function useProductCategories() {
  const { data: categoriesData } = useQuery({
    queryKey: QueryKeys.listCategories(),
    queryFn: () => handleGetRequest('/categories'),
  })

  const categories = useMemo(() => {
    return categoriesData?.data || []
  }, [categoriesData])

  const getCategoryNameById = useMemo(() => {
    const categoryMap = new Map(categories.map((category) => [category.id, category.name]))
    return (categoryId) => categoryMap.get(categoryId) || 'Unknown Category'
  }, [categories])

  const getCategoryById = useMemo(() => {
    const categoryMap = new Map(categories.map((category) => [category.id, category]))
    return (categoryId) => categoryMap.get(categoryId) || null
  }, [categories])

  const getCategoryBySlug = useMemo(() => {
    const categoryMap = new Map(categories.map((category) => [category.categorySlug, category]))
    return (slug) => categoryMap.get(slug) || null
  }, [categories])

  return { getCategoryNameById, getCategoryById, getCategoryBySlug, categories }
}
